import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
    getPermissionDetailFetchSuccess,
    getPermissionDetailFetchFailure,
    createPermissionDetailFetchSuccess,
    createPermissionDetailFetchFailure,
    updatePermissionDetailFetchSuccess,
    updatePermissionDetailFetchFailure,
    deletePermissionFetchSuccess,
    deletePermissionFetchFailure,
} from './reducer';
import { PermissionDetailResType } from 'src/types/permissionDetail';
import { PermissionType } from 'src/types/permission';
import translate from '@translate';
import { getPermissionsListFetch } from '../permissionsList/reducer';

const getPermissionDetailFetchRequest = async (idPermission: string) => {
    const res = await api('get', `api/secure/permissions/${idPermission}`);
    return res.data;
};

function* getPermissionDetailFetch(action: { type: string; payload: string }) {
    try {
        const response: PermissionDetailResType = yield call((): any =>
            getPermissionDetailFetchRequest(action.payload)
        );
        yield put(getPermissionDetailFetchSuccess(response));
    } catch (error) {
        yield put(getPermissionDetailFetchFailure({ error }));
    }
}

export function* getPermissionDetailFetchWatch() {
    yield takeEvery('permissionDetail/getPermissionDetailFetch', getPermissionDetailFetch);
}

const createPermissionDetailFetchRequest = async (data: PermissionType) => {
    const res = await api('post', 'api/secure/permissions', data);
    return res.data;
};

function* createPermissionDetailFetch(action: { type: string; payload: PermissionType }) {
    try {
        const response: PermissionDetailResType = yield call((): any =>
            createPermissionDetailFetchRequest(action.payload)
        );
        getPermissionsListFetch;
        yield put(
            createPermissionDetailFetchSuccess({
                ...response,
                messageSuccess: { title: translate('permissions.message.permissionCreated') },
            })
        );
        yield put(getPermissionsListFetch());
    } catch (error) {
        yield put(createPermissionDetailFetchFailure({ error }));
    }
}

export function* createPermissionDetailFetchWatch() {
    yield takeEvery('permissionDetail/createPermissionDetailFetch', createPermissionDetailFetch);
}

const updatePermissionDetailFetchRequest = async (params: { idPermission: string; data: PermissionType }) => {
    const res = await api('put', `api/secure/permissions/${params.idPermission}`, params.data);
    return res.data;
};

function* updatePermissionDetailFetch(action: {
    type: string;
    payload: { idPermission: string; data: PermissionType };
}) {
    try {
        const response: PermissionDetailResType = yield call((): any =>
            updatePermissionDetailFetchRequest(action.payload)
        );
        yield put(
            updatePermissionDetailFetchSuccess({
                ...response,
                messageSuccess: { title: translate('permissions.message.permissionUpdate') },
            })
        );
        yield put(getPermissionsListFetch());
    } catch (error) {
        yield put(updatePermissionDetailFetchFailure({ error }));
    }
}

export function* updatePermissionDetailFetchWatch() {
    yield takeEvery('permissionDetail/updatePermissionDetailFetch', updatePermissionDetailFetch);
}

const deletePermissionFetchRequest = async (idPermission: string) => {
    const res = await api('delete', `api/secure/permissions/${idPermission}`);
    return res.data;
};

function* deletePermissionFetch(action: { type: string; payload: string }) {
    try {
        const response: PermissionDetailResType = yield call((): any => deletePermissionFetchRequest(action.payload));
        yield put(
            deletePermissionFetchSuccess({
                ...response,
                messageSuccess: { title: translate('permissions.message.permissionDeleted') },
            })
        );
        yield put(getPermissionsListFetch());
    } catch (error) {
        yield put(deletePermissionFetchFailure({ error }));
    }
}

export function* deletePermissionFetchWatch() {
    yield takeEvery('permissionDetail/deletePermissionFetch', deletePermissionFetch);
}
